<template>
  <div>
    <div v-if="carregando==true" class="carregando">
      <img width="100px" src="https://vetmark.s3.amazonaws.com/site/icone.png" />
      <br />
      <br />Carregando...
    </div>
    <div v-if="!dados.dataAprovado">
      <div
        class="alert alert-danger mt-3"
      >Atenção! Sua aprovação ainda está em análise. Em breve poderá acessar sua agenda de disponibilidade.</div>
    </div>

    <div v-else class>
      <h3 id="tituloAgenda" class="mt-3 text-center">Minha Agenda</h3>
      <div
        class="alert alert-info"
      >Mantenha sua agenda mensal atualizada para que os agendamentos sejam realizados com sucesso!</div>
      <form role="form" @submit.stop.prevent="onSubmit">
        <div class="card p-4">
          <h5>Reservar Agenda</h5>
          <hr />
          <div class="row">
            <div class="col-sm-10 col-lg-4 mt-2">
              <v-select
                :options="tiposAgendamento"
                class="form-control"
                name="Tipo de Agendamento"
                placeholder="Tipo de Agendamento"
                taggable
                v-model="form.tipoAgendamento"
                v-validate="{ required: true}"
                :state="validateState('Tipo de Agendamento')"
                :class="validateClass('Tipo de Agendamento')"
              >
                <template #no-options="{  }">Nenhum Registro Encontrado</template>
              </v-select>
            </div>
            <div class="col-sm-2 col-lg-2">
              <n-button v-popover:popover2 outline round type="info">
                <i class="now-ui-icons travel_info"></i>
              </n-button>
              <el-popover
                ref="popover2"
                popper-class="popover popover-primary"
                placement="right"
                width="500"
                trigger="hover"
              >
                <h3 class="popover-header">Tipo de Agendamento</h3>
                <div
                  class="popover-body"
                >Selecione “Geral” para os horários em que estará indisponível devido a outros agendamentos ou “Bloqueio” para os que não deseja receber solicitações de orçamento através da plataforma. Os horários não selecionados como “Geral” ou “Bloqueio” estarão automaticamente DISPONÍVEIS em sua agenda. Também é possível editar ou remover os horários que marcou como indisponíveis clicando em cima deles, diretamente no calendário.</div>
              </el-popover>
            </div>
            <div class="col-sm-12 col-lg-6 mt-2">
              <fg-input
                name="Observação"
                placeholder="Observação"
                v-model="form.observacao"
                :state="validateState('Observação')"
                :class="validateClass('Observação')"
              />
            </div>
            <div class="col-sm-10 col-lg-4 mt-2">
              <fg-input label="Data">
                <el-date-picker
                  :format="'dd/MM/yyyy'"
                  v-model="form.dataInicioAux"
                  :picker-options="pickerOptions"
                  popper-class="date-picker-primary"
                  type="date"
                  placeholder="Data"
                  name="Data"
                  :state="validateState('Data')"
                  :class="validateClass('Data')"
                ></el-date-picker>
              </fg-input>
            </div>
            <div class="col-sm-12 col-lg-3 mt-3">
              <label class="mr-2">Dia todo:</label>
              <n-switch class="mt-2" @input="marcarDiaInteiro()" v-model="form.isDiaInteiro">
                <i class="fa fa-check" style="color:green;" slot="on"></i>
                <i class="fa fa-times" style="color:red;" slot="off"></i>
              </n-switch>
            </div>
            <div class="col-sm-2 col-lg-2 mt-2">
              <fg-input
                v-mask="'##:##'"
                name="Início"
                label="Início"
                v-model="form.horaInicio"
                :state="validateState('Início')"
                :class="validateClass('Início')"
                :disabled="disabledDiaInteiro"
              />
            </div>

            <div class="col-sm-2 col-lg-2 mt-2">
              <fg-input
                v-mask="'##:##'"
                name="Final"
                label="Final"
                v-model="form.horaFim"
                :state="validateState('Final')"
                :class="validateClass('Final')"
                :disabled="disabledDiaInteiro"
              />
            </div>

            <div class="col-sm-12 col-lg-4 mt-4">
              <label class="mr-2">Repetir:</label>
              <n-switch class="mt-2" @input="abreRepete()" v-model="form.isRecorrencia">
                <i class="fa fa-check" style="color:green;" slot="on"></i>
                <i class="fa fa-times" style="color:red;" slot="off"></i>
              </n-switch>
              <n-button v-popover:popover1 outline round type="info">
                <i class="now-ui-icons travel_info"></i>
              </n-button>
              <el-popover
                ref="popover1"
                popper-class="popover popover-primary"
                placement="top"
                width="200"
                trigger="hover"
              >
                <h3 class="popover-header">Vai Repetir?</h3>
                <div
                  class="popover-body"
                >Ao Selecionar essa opção você pode fazer esse agendamento se repetir diariamente ou por dias da semana até uma data final.</div>
              </el-popover>
            </div>
            <div v-if="repete==true" class="col-sm-10 col-lg-4 mt-2">
              <fg-input label="Repete até dia">
                <el-date-picker
                  :format="'dd/MM/yyyy'"
                  v-model="form.dataFimAux"
                  popper-class="date-picker-primary"
                  type="date"
                  placeholder="Data Final"
                  name="Data Final"
                  :state="validateState('Data Final')"
                  :class="validateClass('Data Final')"
                ></el-date-picker>
              </fg-input>
            </div>
            <div v-if="repete==true" class="col-sm-12 col-lg-3 mt-2">
              <label>Modo de Repetição</label>
              <div>
                <v-select
                  :options="modosDeRepeticao"
                  class="form-control inputH100"
                  name="Modo de Repetição"
                  placeholder="Modo"
                  v-model="form.modoRepeticao"
                  v-validate="{ required: true}"
                  :state="validateState('Modo de Repetição')"
                  :class="validateClass('Modo de Repetição')"
                >
                  <template #no-options="{  }">Nenhum Registro Encontrado</template>
                </v-select>
              </div>
            </div>
            <div v-if="repete==true && form.modoRepeticao.id=='S'" class="col-sm-12 col-lg-5 mt-2">
              <label>Dias de Repetição</label>
              <div>
                <v-select
                  :options="diasDaSemana"
                  class="form-control inputH100"
                  name="Dias que se Repete"
                  placeholder="Dias da Semana"
                  multiple
                  v-model="form.repeticao"
                  v-validate="{ required: true}"
                  :state="validateState('Dias que se Repete')"
                  :class="validateClass('Dias que se Repete')"
                >
                  <template #no-options="{  }">Nenhum Registro Encontrado</template>
                </v-select>
              </div>
            </div>
            <div class="col-sm-12 col-lg-12 mt-2 text-right">
              <n-button nativeType="submit" class="text-white mt-4" round type="success">
                <i class="fa fa-plus"></i> Adicionar
              </n-button>
            </div>
            <div class="col-sm-12 col-lg-12 mt-2">
              <errosAlert
                :exibeErro="exibeErro"
                :msgErro="msgErro"
                :listaErro="$validator.errors.all()"
              ></errosAlert>
            </div>
          </div>
        </div>
      </form>
      <agenda
        :codPessoa="codPessoa"
        :refazBusca="refazBusca"
        @buscaFinalizada="buscaFinalizada"
        @adicionaItemAgenda="adicionaItemAgenda"
        @removerItem="removeEvento"
        :edit="true"
      ></agenda>
    </div>
  </div>
</template>
<script>
import {
  Button,
  Checkbox,
  Radio,
  FormGroupInput,
  Slider,
  Switch,
  Card
} from "@/components";

import { Popover, Tooltip, DatePicker } from "element-ui";
import lang from "element-ui/lib/locale/lang/pt-br";
import locale2 from "element-ui/lib/locale";

import agenda from "./agenda";
import service from "./../../services";

import errosAlert from "./errosAlert";
import jwt from "jsonwebtoken";
import moment from "moment";

import locale from "./../../locale";
export default {
  components: {
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Radio.name]: Radio,
    [FormGroupInput.name]: FormGroupInput,
    [Switch.name]: Switch,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Popover.name]: Popover,
    Slider,
    Card,
    agenda,
    errosAlert
  },
  data() {
    return {
      carregando: false,
      exibeEdit: false,
      codPessoa: null,
      refazBusca: false,
      repete: false,
      exibeErro: false,
      disabledDiaInteiro: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      dados: {},
      msgErro: "",
      tiposAgendamento: [],
      modosDeRepeticao: [
        { id: "D", label: "Diário" },
        { id: "S", label: "Semanal" }
      ],
      diasDaSemana: [
        { id: 1, label: "Segunda" },
        { id: 2, label: "Terça" },
        { id: 3, label: "Quarta" },
        { id: 4, label: "Quinta" },
        { id: 5, label: "Sexta" },
        { id: 6, label: "Sabado" },
        { id: 0, label: "Domingo" }
      ],
      form: {
        codTipoAgendamento: null,
        dataInicioAux: moment(),
        dataFimAux: moment(),
        horaInicio: moment().format("HH:mm"),
        horaFim: moment()
          .add(1, "hours")
          .format("HH:mm"),
        observacao: "",
        recorrencia: null,
        diaSemana: [],
        isRecorrencia: false,
        repeticao: [],
        modoRepeticao: { id: "D", label: "Diário" }
      }
    };
  },
  methods: {
    adicionaItemAgenda(obj) {
      console.log(obj);
      this.form.dataInicioAux = moment(obj.data).utc();
      console.log(this.form.dataInicioAux);
      this.$scrollTo("#tituloAgenda");
    },
    marcarDiaInteiro() {
      this.disabledDiaInteiro = !this.disabledDiaInteiro;
      if(this.form.isDiaInteiro){
        this.form.horaInicio = "00:00";
        this.form.horaFim = "23:59";
      }else{
        this.form.horaInicio = moment()
          .format("HH:mm");
        this.form.horaFim = moment()
          .add(1, "hours")
          .format("HH:mm");
      }
    },
    abreRepete() {
      this.repete = !this.repete;
      this.form.dataFimAux = moment();
      this.form.horaFim = moment()
        .add(1, "hours")
        .format("HH:mm");
      this.form.recorrencia = null;
      this.form.diaSemana = [];
      this.form.repeticao = [];
      this.form.modoRepeticao = { id: "D", label: "Diário" };
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (this.veeFields[ref]) {
        if (this.veeFields[ref].dirty) {
          if (this.veeFields[ref].valid == false) {
            return "has-danger";
          } else {
            return "has-success";
          }
        }
      }
      return null;
    },
    removeEvento(item) {
      this.carregando = true;
      service
        .delete("pessoa", this.codPessoa + "/agenda/" + item.codAgendamento, {})
        .then(res => {
          this.refazBusca = true;
          this.carregando = false;
        });
    },
    buscaFinalizada() {
      this.refazBusca = false;
    },
    resetForm() {
      return new Promise((resolve, reject) => {
        this.form = {
          codTipoAgendamento: null,
          dataInicioAux: moment(),
          dataFimAux: moment(),
          horaInicio: moment().format("HH:mm"),
          horaFim: moment()
            .add(1, "hours")
            .format("HH:mm"),
          observacao: "",
          recorrencia: null,
          diaSemana: [],
          isRecorrencia: false,
          repeticao: [],
          modoRepeticao: { id: "D", label: "Diário" }
        };
        this.$nextTick(() => this.$validator.reset());
        resolve();
      });
    },
    onSubmit() {
      console.log(this.form);
      this.$validator.validateAll().then(result => {
        if (result) {
          this.carregando = true;
          console.log(this.codPessoa, this.form);
          this.form.codTipoAgendamento = this.form.tipoAgendamento.id;
          this.form.dataInicio = moment(this.form.dataInicioAux).format(
            "YYYY-MM-DD"
          );

          if (this.form.isRecorrencia == true) {
            this.form.recorrencia = this.form.modoRepeticao.id;
            this.form.dataFim = moment(this.form.dataFimAux).format(
              "YYYY-MM-DD"
            );
            if (this.form.repeticao.length > 0) {
              this.form.diaSemana = [];
              this.form.repeticao.forEach(element => {
                this.form.diaSemana.push(element.id);
              });
            }
          } else {
            this.form.dataFim = this.form.dataInicio;
            delete this.form.recorrencia;
            delete this.form.diaSemana;
          }
          if (this.form.diaSemana)
            this.form.diaSemana = this.form.diaSemana.toString();
          service
            .post("pessoa", this.codPessoa + "/agenda", this.form)
            .then(res => {
              this.carregando = false;
              this.exibeErro = false;
              swal("", "Agendamento adicionado com sucesso!", "success");
              this.resetForm();
              this.refazBusca = true;
              this.disabledDiaInteiro = false;
            })
            .catch(error => {
              console.log(error);
              this.exibeErro = true;
              this.msgErro = "Não foi possível Adicionar. <br> " + error;
              this.carregando = false;
              this.refazBusca = true;
            });
          this.carregando = false;
        }
      });
    },
    buscarDados() {
      const token = localStorage.getItem("user-token");
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.codPessoa = this.decoded.codPessoa;

      this.carregando = true;
      service
        .post("pessoa", "BuscarPessoa/" + this.decoded.codPessoa, {})
        .then(res => {
          if (res.data.length > 0) {
            this.dados = res.data[0];

            this.carregando = false;
            console.log(this.dados, this.refazBusca);
            setTimeout(() => {
              this.refazBusca = true;
            }, 1000);

            console.log("this.dados, ", this.refazBusca);
          } //else this.$router.push("/401");
        })
        .catch(e => {
          console.log(e);
        });
    },
    buscarTipos() {
      this.carregando = true;
      service.getAll("dominio", {}, "tipo-agendamento").then(res => {
        res.data.forEach(element => {
          this.tiposAgendamento.push({
            id: element.codTipoAgendamento,
            label: element.nome
          });
        });
        console.log(this.tiposAgendamento);
        this.carregando = false;
      });
    }
  },
  mounted() {
    locale2.use(lang);
    this.buscarDados();
    this.buscarTipos();
    this.$validator.localize("ptBr", locale);
  }
};
</script>
<style scoped>
select {
  padding: 10px !important;
}
input[type="radio"],
input[type="checkbox"] {
  margin-right: 10px !important;
}
.btnbuscar {
  font-size: 24px;
  text-transform: uppercase;
  color: #094049;
}
</style>
